import * as Yup from "yup";
import { campo_obligatorio, email_invalido } from "../../utils/traductor";
import {
  getApellido,
  getemail,
  getIdioma,
  getLocalidad,
  getTelefono,
  getContactosEmergencia,
  getavatar,
  getNombre,
  getNombreBanco,
  getTitular,
  getCBU,
} from "../../utils/variablesLocales";

export function initialValues() {
  return {
    nombre: getNombre(),
    apellido: getApellido(),
    email: getemail(),
    idioma: getIdioma(),
    localidad: getLocalidad(),
    telefono: getTelefono(),
    contactosemergencia: getContactosEmergencia(),
    avatar: getavatar().replace("uploads/", ""),
    fileAvatar: null,
    nombreBanco: getNombreBanco(),
    titular: getTitular(),
    CBU: getCBU(),
  };
}

export function validationSchema() {
  return Yup.object({
    nombre: Yup.string().required(` ${campo_obligatorio} `),
    apellido: Yup.string().required(` ${campo_obligatorio} `),
    idioma: Yup.string().required(` ${campo_obligatorio} `),
    // localidad: Yup.string().required(` ${campo_obligatorio} `),
    email: Yup.string()
      .email(` ${email_invalido} `)
      .required(` ${campo_obligatorio} `),
    telefono: Yup.string().required(` ${campo_obligatorio} `),
    nombreBanco: Yup.string(),
    titular: Yup.string(),
    CBU: Yup.string(),
  });
}
